import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { AttachmentBlock } from "./AttachmentBlock";
import { defaultData } from "./AttachmentBlockDefaultData";
import { meta } from "./AttachmentBlockMetaData";
import { AttachmentBlockEditor as Editor } from "./Editor";

export const AttachmentBlockExport: BlockExport = {
  type: "component",
  Block: AttachmentBlock,
  imagePreview: {
    type: "icon",
    name: "hw-paperclip",
    size: 24,
  },
  Editor,
  defaultData,
  meta,
};
